module.exports = __webpack_public_path__ + "static/media/s4b-logo.aee13c0e.png";